import { render } from "./ViewSwitcher.vue?vue&type=template&id=2450b294&scoped=true"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js"

import "./ViewSwitcher.vue?vue&type=style&index=0&id=2450b294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2450b294"]])

export default __exports__